// Module
var code = `<div class="arch-embed-header">
    <h3>Natural Language as a Controlled Interface to Architecture</h3>
    <p class="subhead">
        AI doesn’t modify code directly — it operates against architectural rules and validation.
    </p>
</div>
<div class="arch-top">
    <div class="vbl-col">
        <div class="col-header">
            <h3>V — View</h3>
            <div class="label">PageView : ViewStream</div>
        </div>
        <pre>{
  "renders": "DOM",
  "template": "page.tmpl.html",
  "traits": [
    "PageItemCore",
    "Custom"
  ],
  "listensTo": ["CHANNEL_ROUTE"],
  "broadcasts": [{ "a": "click" }]
}</pre>
        <p class="caption">Renders UI. Owns lifecycle.</p>
    </div>

    <div class="vbl-col">
        <div class="col-header">
            <h3>B — Behavior</h3>
            <div class="label">CHANNEL_APP_STATUS</div>
        </div>
        <pre>{
  "actions": [
    "INIT",
    "DATA",
    "SETTING"
  ],
  "traits": ["Status","Settings"],
  "sendCachedPayload": true
}</pre>
        <p class="caption">Owns events and synchronization.</p>
    </div>

    <div class="vbl-col">
        <div class="col-header">
            <h3>L — Logic</h3>
            <div class="label">PageItem-CoreTraits</div>
        </div>
        <pre>{
  "owns": [
    "AddPageItems",
    "GetTemplate"
  ],
  "allowedSideEffects": [
    "appendView",
    "injectStyles"
  ],
  "disallowed": ["routing"]
}</pre>
        <p class="caption">Owns decisions, not wiring.</p>
    </div>
</div>

<div class="arch-middle">

    <div class="funnel">
        <span class="step">Intent</span>
        <span class="arrow">→</span>
        <span class="step">Decompose</span>
        <span class="arrow">→</span>
        <span class="step">Map to V / B / L</span>
        <span class="arrow">→</span>
        <span class="step">Generate in Silos</span>
        <span class="arrow">→</span>
        <span class="step">Validated Patch</span>
    </div>

    <div class="intent-block">
        <blockquote>
            “Fetch data from a URL and display it<br/>
            in a new landing page section”
        </blockquote>
    </div>

    <div class="decompose">
        <pre>["fetch", "transform", "render", "sync"]</pre>
    </div>

    <div class="table-wrapper">
        <table class="mapping">
            <thead>
            <tr>
                <th>Capability</th>
                <th>Layer</th>
                <th>Artifact</th>
            </tr>
            </thead>
            <tbody>
            <tr>
                <td>fetch</td>
                <td>B</td>
                <td>Channel</td>
            </tr>
            <tr>
                <td>transform</td>
                <td>L</td>
                <td>Trait</td>
            </tr>
            <tr>
                <td>render</td>
                <td>V</td>
                <td>ViewStream</td>
            </tr>
            <tr>
                <td>sync</td>
                <td>B → V</td>
                <td>Wiring</td>
            </tr>
            </tbody>
        </table>
    </div>

    <div class="silos">
        <span>[ Channel ]</span>
        <span>[ Trait ]</span>
        <span>[ Template ]</span>
        <span>[ View ]</span>
    </div>

    <div class="validated">
      <pre>{
  "applyPatch": ["addChannel","addTrait","addView","wire"],
  "preflight": "pass"
}</pre>
    </div>

</div>

<div class="arch-bottom">
    <p class="thesis">
        Traditional AI workflows rely on prompts and inferred intent.<br/>
        <strong>SpyneJS relies on structure.</strong>
    </p>
    <p class="sub">
        Architecture expressed as data eliminates guesswork.
    </p>
</div>
`;
// Exports
module.exports = code;